import {create} from 'zustand'
import socket from '../socketio/socketio.js'
import {closeHandoverTab, openHandoverTab, sendToken} from '../utils/loginAsHandover.js'

const useLoginStore = create(() => ({
    // Pass a tab opened in the click when calling this after another async call
    loginAsReseller: (id, url, callback, win = openHandoverTab()) => {
        socket.emit('login.loginAsReseller', sessionStorage.token, id, (err, token) => {
            if (err) {
                closeHandoverTab(win)
            } else {
                sendToken(win, token, url || '/')
            }

            typeof callback === 'function' && callback(err)
        })
    }
}))

export default useLoginStore
